import {
  button,
  div,
  span
} from '@srfnstack/fntags'
import { PinToPinterest } from './PinToPinterest.js'

export const PublishControls = ({ product, saving, variantsDirty, handlePushToPrintify, handlePublishToEtsy, handleSync, handleUnpublish, handleReject }) =>
  div({ class: 'flex gap-2 flex-wrap w-full md:w-auto' },
    product.bindAs(p => {
      if (!p) return span()
      // A product is "pushed" whenever it has a Printify product behind it —
      // regardless of the exact status (PUSHED_TO_PRINTIFY, PENDING_ONE_CLICK_APPROVAL
      // from the validate flow, HOLD_VALIDATION_FAILED, PUBLISHED). This is the
      // reliable signal for showing View-in-Printify / Publish-to-Etsy.
      const pushed = !!p.printify_product_id
      if (!pushed) {
        return button({
          class: 'btn btn-primary flex-1 md:flex-none',
          onclick: handlePushToPrintify,
          disabled: saving.bindAttr()
        }, saving.bindAs(s => s
          ? span({ class: 'flex items-center gap-2' }, span({ class: 'loading loading-spinner loading-xs' }), 'Processing...')
          : span({ class: 'flex items-center gap-2' },
            span({ class: 'material-symbols-rounded text-base' }, 'cloud_upload'),
            p.printify_product_id ? 'Re-push to Printify' : 'Push to Printify'
          )
        ))
      }
      return div({ class: 'flex gap-2 flex-wrap' },
        button({
          class: 'btn btn-secondary btn-outline flex-1 md:flex-none',
          onclick: () => window.open(`https://printify.com/app/product-details/${p.printify_product_id}`),
          title: 'View product in Printify app'
        }, span({ class: 'flex items-center gap-2' }, span({ class: 'material-symbols-rounded' }, 'open_in_new'), 'View in Printify')),
        button({
          class: 'btn btn-info btn-outline flex-1 md:flex-none',
          onclick: handleSync,
          disabled: saving.bindAttr()
        }, span({ class: 'flex items-center gap-2' },
          span({ class: 'material-symbols-rounded text-base' }, 'sync'),
          'Sync'
        )),
        // When colors/variants were edited, the re-push pulses (warning) and the Etsy
        // publish is disabled until the changes are synced to Printify.
        button({
          class: (variantsDirty ? variantsDirty.bindAttr(d => `btn btn-warning flex-1 md:flex-none ${d ? 'animate-pulse ring-2 ring-warning' : 'btn-outline'}`) : 'btn btn-warning btn-outline flex-1 md:flex-none'),
          onclick: handlePushToPrintify,
          disabled: saving.bindAttr()
        }, span({ class: 'flex items-center gap-2' },
          span({ class: 'material-symbols-rounded text-base' }, 'cloud_upload'),
          'Re-push to Printify'
        )),
        button({
          class: 'btn btn-success flex-1 md:flex-none',
          onclick: handlePublishToEtsy,
          disabled: saving.bindAttr(s => (s || (variantsDirty && variantsDirty())) || undefined),
          title: (variantsDirty ? variantsDirty.bindAttr(d => d ? 'Re-push to Printify first — your color/variant changes aren\'t synced yet' : 'Publish to Etsy') : undefined)
        }, saving.bindAs(s => s
          ? span({ class: 'flex items-center gap-2' }, span({ class: 'loading loading-spinner loading-xs' }), 'Processing...')
          : 'Publish to Etsy'
        )),
        p.etsy_listing_id
          ? button({
            class: 'btn btn-warning btn-outline flex-1 md:flex-none',
            onclick: handleUnpublish,
            disabled: saving.bindAttr()
          }, 'Remove from Etsy')
          : span(),
        // Manual pin — drives Pinterest traffic to the listing. Available once the
        // product has a mockup (pushed); most useful once it's live on Etsy.
        PinToPinterest({ product })
      )
    }),
    button({
      class: 'btn btn-error btn-outline flex-1 md:flex-none',
      onclick: handleReject
    }, 'Reject Product')
  )
